<template>
  <v-card>
    <v-card-title class="blue-grey lighten-5 text-primary">
      {{ tDefecationTitle }}
    </v-card-title>

    <v-form ref="post_defecation_form">

      <v-card-text class="py-3">

        <time-picker
          color="primary"
          base-color="primary"
          v-model="recordedAt"
          :label="tDefecationTime"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          variant="outlined"
          density="compact"
        />

        <v-select
          color="primary"
          base-color="primary"
          v-model="state"
          :items="choices"
          item-title="title"
          item-value="value"
          :rules="[rules.required]"
          :label="tDefecationState"
          variant="outlined"
          density="compact"
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="close"
          color="error"
          variant="text"
        >
          {{ tCancel }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="clickPost"
          :loading="btnLoading"
          color="primary"
          variant="flat"
        >
          {{ tSubmit }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

    </v-form>

  </v-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { t } from '@/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

import TimePicker from '@/components/molecules/TimePicker.vue';
import { dailyReportModule } from '@/store/entityModules/dailyReport';

// model
import type { VForm } from 'vuetify/components';
import {
  DefecationStatus,
  DefecationStatusType,
} from '../../../node_modules/chaild-entity/src/component/home/defecation/types';

interface DataType {
  recordedAt: string;
  state: string;
  btnLoading: boolean;
  isRecordetAtPicker: boolean;
  choices: Array<{
    title: string;
    value: DefecationStatusType;
  }>;
}

export default defineComponent({
  name: 'DefecationModal',
  components: {
    TimePicker,
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  computed: {
    tDefecationTitle(): string {
      return t('record.modal.defecationTitle', '排便');
    },
    tDefecationTime(): string {
      return t('record.modal.defecationTime', '時間');
    },
    tDefecationState(): string {
      return t('record.modal.defecationState', '状態');
    },
    tCancel(): string {
      return t('common.cancel', 'キャンセル');
    },
    tSubmit(): string {
      return t('common.submit', '送信');
    },
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).post_defecation_form;
    },
  },

  watch: {
    isOpen: {
      handler(val: boolean) {
        if (val) {
          this.recordedAt = dayjs().format('HH:00');
          this.state = '';
        }
      },
      deep: true,
    },
  },

  data: (): DataType =>({
    recordedAt: dayjs().format('HH:00'),
    state: '',
    btnLoading: false,
    isRecordetAtPicker: false,
    choices: [
      {
        title: t('record.status.defecationHard', '硬い'),
        value: DefecationStatus.hard,
      },
      {
        title: t('record.status.defecationNormal', '普通'),
        value: DefecationStatus.normal,
      },
      {
        title: t('record.status.defecationSoft', '軟らかい'),
        value: DefecationStatus.soft,
      },
      {
        title: t('record.status.defecationDiarrhea', '水様便（下痢）'),
        value: DefecationStatus.diarrhea,
      },
    ],
  }),

  methods: {
    allowedStep: (m) => m % 5 === 0,
    close() {
      this.$emit('close');
    },
    async clickPost() {
      const { valid } = await this.form.validate();
      if (valid) {
        this.btnLoading = true;
        try {
          const recordedAtHour = this.recordedAt.split(':')[0];
          const recordedAtMinutes = this.recordedAt.split(':')[1];
          const recordedAtTime = dayjs().hour(Number(recordedAtHour)).minute(Number(recordedAtMinutes));
          const response = await dailyReportModule.postDefecation({
            childId: this.childId,
            date: this.selectedDate,
            recordedAt: dayjs(recordedAtTime).toISOString(),
            state: this.state,
          });
          this.$emit('posted');
          this.$emit('close');
          this.btnLoading = false;
        } catch (error) {
          this.$emit('close');
          this.btnLoading = false;
        }
      }
    },
  },
});
</script>
<style lang="scss" scoped>
</style>
